import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';

import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../common/store/store';
import { ZoneMap } from './ZoneMap';
// https://developers.google.com/maps/documentation/javascript/examples/polygon-simple?_gl=1*15eo889*_up*MQ..*_ga*NTE4Mzk2NjYzLjE3NDczMTAwNzc.*_ga_NRWSTWS78N*czE3NDczMTAwNzYkbzEkZzEkdDE3NDczMTExODQkajAkbDAkaDA.
// https://developers.google.com/maps/documentation/javascript/examples/drawing-tools?_gl=1*3pylu0*_up*MQ..*_ga*MTY4NjgwNTA5MS4xNzQ3MzExNTMw*_ga_NRWSTWS78N*czE3NDczMTE1MjkkbzEkZzEkdDE3NDczMTE1MzAkajAkbDAkaDA.




export default () => {

    const googleMapLoaded = useSelector((state: AppState) => state.googleMap.loaded);

    return <Master>
        <Container maxWidth={false}>
            <Typography variant='h1'>Zones</Typography>
            {googleMapLoaded ? <ZoneMap /> : <Alert severity='info'><CircularProgress /> Chargement de la map</Alert>}
        </Container>
    </Master>;
};
